module.exports = __webpack_public_path__ + "img/microscopioID@2x.d4e815dc.png";